export const LANDING = {
  nav: 'landing-nav',
  navLogo: 'landing-nav-logo',
  navComponents: 'landing-nav-components',
  navTiers: 'landing-nav-tiers',
  navCta: 'landing-nav-cta',
  heroSection: 'landing-hero-section',
  heroHeadline: 'landing-hero-headline',
  heroSubtext: 'landing-hero-subtext',
  heroCtaBtn: 'landing-hero-cta-btn',
  featuresSection: 'landing-features-section',
  featuresSectionTitle: 'landing-features-section-title',
  featureCard: 'landing-feature-card',
  tiersSection: 'landing-tiers-section',
  tiersSectionTitle: 'landing-tiers-section-title',
  tierCard: 'landing-tier-card',
  ctaSection: 'landing-cta-section',
  ctaHeadline: 'landing-cta-headline',
  ctaBtn: 'landing-cta-btn',
  footer: 'landing-footer',
  partnershipsNav: 'landing-nav-partnerships',
};
